var map = {
	"./arabic.json": 695,
	"./bulgarian.json": 696,
	"./czech.json": 697,
	"./denmark.json": 698,
	"./english.json": 699,
	"./finnish.json": 700,
	"./greek.json": 701,
	"./indonesian.json": 702,
	"./malay.json": 703,
	"./norwegian.json": 704,
	"./romanian.json": 705,
	"./slovakia.json": 706,
	"./swedish.json": 707,
	"./thai.json": 708
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 160;


//////////////////
// WEBPACK FOOTER
// ./src/locales/prizeo ^\.\/.*\.json$
// module id = 160
// module chunks = 0